import { render, staticRenderFns } from "./PrivacyTreatment.vue?vue&type=template&id=8738bae2&"
import script from "./PrivacyTreatment.vue?vue&type=script&lang=ts&"
export * from "./PrivacyTreatment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports